<div class="container">
    <div class="content">
        <app-neuroglancer-frame></app-neuroglancer-frame>
    </div>

    <div class="overlay">
        <app-top-bar [showViewerControls]="true"></app-top-bar>
        <div class="viewer-controls">
            <app-side-panel
                [visible]="true"
                (panelToggled)="layerControlsToggled($event)"
                position="left"
                class="side-panel-left"
            >
                <app-viewer-controls-panel></app-viewer-controls-panel>
            </app-side-panel>
            <app-side-panel
                [visible]="(selectionPanelVisible$ | async) || false"
                position="right"
                class="side-panel-right"
                (tabChangeRequested)="changeTab($event)"
                [currentTab]="tabToDisplay"
            >
                <div [hidden]="tabToDisplay !== Tabs.GATING">
                    <app-free-selection-panel></app-free-selection-panel>
                </div>
                <div
                    [hidden]="
                        tabToDisplay !== Tabs.HIERARCHICAL_GATING &&
                        tabToDisplay !== Tabs.AUTO_CELL_TYPE_DETECTION
                    "
                >
                    <app-hierarchical-selection-panel></app-hierarchical-selection-panel>
                </div>
                <div [hidden]="tabToDisplay !== Tabs.RECURRENT_NEIGHBORHOODS">
                    <app-recurrent-neighborhoods-result></app-recurrent-neighborhoods-result>
                </div>
                <div [hidden]="tabToDisplay !== Tabs.NEIGHBORHOOD_ENRICHMENT">
                    <app-neighborhood-enrichment-result></app-neighborhood-enrichment-result>
                </div>
                <div *ngIf="tabToDisplay === Tabs.PLOTTING">
                    <app-plotting-panel></app-plotting-panel>
                </div>
                <!-- <div [hidden]="tabToDisplay !== Tabs.CELL_TYPE_DETECTION">
                    <app-cell-type-detection-result></app-cell-type-detection-result>
                </div>
                <div [hidden]="tabToDisplay !== Tabs.AUTO_CELL_TYPE_DETECTION">
                    <app-auto-cell-type-detection-panel></app-auto-cell-type-detection-panel>
                </div> -->
            </app-side-panel>
        </div>
    </div>
</div>
